import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl } from '@angular/forms';

import { RelatedToType } from '@shared/enums';
import { FormPanelMeta, PanelComponentBase } from '../panels.types';

@Component({
  selector: 'app-panel-comments',
  templateUrl: './comments.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PanelCommentsComponent extends PanelComponentBase<FormPanelMeta> implements OnInit {
  @Input() readonly: boolean = false;
  @Output() onEditPanelDef: EventEmitter<any> = new EventEmitter();

  title = new FormControl('');
  relatedToTypeEnum = RelatedToType;

  constructor(private changeDetectorRef: ChangeDetectorRef) {
    super();
  }

  ngOnInit(): void {
    this.ui = { ...this.ui, editMode: false };
    this.panelDefMemento = JSON.parse(JSON.stringify(this.panelDef));
  }

  cancelEdits(): void {
    this.ui = { ...this.ui, editMode: !this.ui.editMode };
    this.panelDef = JSON.parse(JSON.stringify(this.panelDefMemento));
    this.editToggled.emit({ toggle: false, panelDef: this.panelDef });
  }

  toggleEditMode(): void {
    this.ui = { ...this.ui, editMode: !this.ui.editMode };
    this.title.setValue(this.panelDef.title);
    this.editToggled.emit({ toggle: true, panelDef: this.panelDef });
    this.changeDetectorRef.detectChanges();
  }

  saveLayout(): void {
    this.panelDef = {
      ...this.panelDef,
      title: this.title.value,
      meta: { ...this.panelDef.meta, fields: this.panelDef.meta.fields.filter((row) => row.length) },
    };
    this.panelDefUpdated.emit(this.panelDef);
    this.panelDefMemento = JSON.parse(JSON.stringify(this.panelDef));
    this.ui = { ...this.ui, editMode: !this.ui.editMode };
    this.editToggled.emit({ toggle: false, panelDef: this.panelDef });
  }
}
